import {Container, Singleton} from "typescript-ioc";
import Product from "@/model/Product";
import StorageKey from "@/storage/StorageKey";
import BizStorage from './BizStorage';
import {LocalStorageWrapper} from "@/storage/StorageWrapper";

@Singleton
export default abstract class ProductStorage extends BizStorage<Product> {
    protected key = StorageKey.PRODUCT
}

class ProductStorageImpl extends ProductStorage {
    storage = Container.get(LocalStorageWrapper)
}

Container.bind(ProductStorage).to(ProductStorageImpl)
